module.exports = __webpack_public_path__ + "static/a-home-behind-the-lens-cta-banner-1920x515-1223b1f3b276c33a8b8d85040a474e9e.jpg";